import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import media from '../../../constants/media';
import { ReactComponent as IconBox } from '../../../icons/box.svg';

const StyledWrapper = styled.div`
	display: flex;
	justify-content: flex-end;
	align-items: center;
	width: 100%;
	padding-right: 10%;
	${media.mobileOnly`
        display: none;
    `}
`;

const StyledImageWrapper = styled.div`
	position: relative;
`;

const sharedStyles = css`
	position: absolute;
	width: 11rem;
	height: 5rem;
	font-size: 1.2rem;
	color: ${({ theme }) => theme.colors.black};
`;

const StyledImage = styled.div`
	svg {
		width: 18rem;
		height: 16rem;

		path {
			fill: ${({ theme }) => theme.colors.secondary};
		}
	}
`;

const StyledHeight = styled.div`
	top: 50%;
	left: -8%;
	transform: translate3d(-65%, 5%, 0) rotate(90deg);
	${sharedStyles};
`;

const StyledWidth = styled.div`
	bottom: 0;
	left: 0;
	transform: translate3d(0%, 90%, 0) rotate(21deg);
	${sharedStyles};
`;

const StyledLength = styled.div`
	bottom: 0;
	right: 0;
	transform: translate3d(40%, 55%, 0) rotate(-21deg);
	${sharedStyles};
`;

interface Props {
	width: string;
	height: string;
	length: string;
}

const BoxImage: FC<Props> = ({ height, width, length }) => {
	const { t } = useTranslation('common');
	return (
		<StyledWrapper>
			<StyledImageWrapper>
				<StyledHeight>
					<div>{`${t('height')} ${height.toString().length > 0 ? height : '?'} cm`}</div>
				</StyledHeight>
				<StyledWidth>
					<div>{`${t('width')} ${width.toString().length > 0 ? width : '?'} cm`}</div>
				</StyledWidth>
				<StyledLength>
					<div>{`${t('length')} ${length.toString().length > 0 ? length : '?'} cm`}</div>
				</StyledLength>
				<StyledImage>
					<IconBox />
				</StyledImage>
			</StyledImageWrapper>
		</StyledWrapper>
	);
};

export default BoxImage;
